import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Navigation from './components/Navigation';
import Home from './pages/Home';
import Schedule from './components/Schedule';
import Lessons from './pages/Lessons';
import Waiver from './pages/Waiver';
import Footer from './components/Footer';
import AboutUs from './pages/AboutUs';
import JobOpportunities from './pages/JobOpportunities';
import EventCoordinator from './pages/EventCoordinator';
import ProgramAssistant from './pages/ProgramAssistant';
import SummerCamp from './pages/SummerCamp';
import PrintSchedule from './pages/PrintSchedule';
import SalsaAtThePark from './pages/SalsaAtThePark';
import FreeEvents from './pages/FreeEvents';
import Contact from './components/Contact';


const App = () => {
  return (
    <Router>
      <div className="min-h-screen bg-[#e6dad1]">
        <Navigation />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/schedule" element={<Schedule />} />
          <Route path="/lessons" element={<Lessons />} />
          {/* Redirect /classes to /lessons */}
          <Route path="/classes" element={<Navigate to="/lessons" replace />} />
          <Route path="/about" element={<AboutUs />} />
          <Route path="/waiver" element={<Waiver />} />
          {/* Job opportunity routes */}
          <Route path="/jobs" element={<JobOpportunities />} />
          <Route path="/jobs/event-coordinator" element={<EventCoordinator />} />
          <Route path="/jobs/program-assistant" element={<ProgramAssistant />} />
          {/* Summer Camp route */}
          <Route path="/summer-camp" element={<SummerCamp />} />
          {/* Salsa at the Park route */}
          <Route path="/salsa-at-the-park" element={<SalsaAtThePark />} />
          <Route path="/free-events" element={<FreeEvents />} />
          <Route path="/salsa-at-the-plaza-2024-old" element={<FreeEvents />} />
          {/* Print Schedule route */}
          <Route path="/print-schedule" element={<PrintSchedule />} />          
        </Routes>
        <Contact/>
        <Footer />
      </div>
    </Router>
  );
};

export default App;